import { createSelector } from '@reduxjs/toolkit';
import { globalStylesAdapter, globalStylesSliceName } from '../reducers/GlobalStyles';
export const globalStylesSelectors = globalStylesAdapter.getSelectors(({
  [globalStylesSliceName]: state
}) => state);
export const selectGlobalStylesheet = createSelector(globalStylesSelectors.selectAll, styles => styles.reduce((stylesheet, {
  selector,
  style
}) => {
  stylesheet[selector] = style;
  return stylesheet;
}, {}));